/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg id="e3081d5b-c6c8-48fe-aa18-33318e4b8fd3" width="55.38" height="95.58" viewBox="0 0 55.38 95.58" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <g id="b58c9471-21f9-441b-a45e-ef93d5baf6c4">
          <g id="a72c25c8-bbd2-4bb9-9b86-87a402946276">
            <g id="a4ac91c2-450f-49eb-92c7-49beedfde5b7">
              <path id="ae40a867-c4c9-4f66-ab62-cf476f6628d4" d="M99,30H56.41A6.41,6.41,0,0,0,50,36.42v82.74a6.41,6.41,0,0,0,6.42,6.42H99a6.41,6.41,0,0,0,6.42-6.42V36.42A6.42,6.42,0,0,0,99,30ZM56.41,32.5H99a3.92,3.92,0,0,1,3.92,3.92v82.74A3.91,3.91,0,0,1,99,123.08H56.41a3.91,3.91,0,0,1-3.92-3.92V36.42A3.92,3.92,0,0,1,56.41,32.5Z" transform="translate(-49.99 -30)" fill="#0e497b"/>
              <path id="a123c5c3-e21d-4e3a-836f-855da037c6d4" d="M104.11,42.92a1.25,1.25,0,0,1,.13,2.49h-53a1.25,1.25,0,0,1-.13-2.5h53Z" transform="translate(-49.99 -30)" fill="#0e497b"/>
              <path id="a6a2323a-0189-4502-ac29-f5d324129fef" d="M104.11,107.56a1.25,1.25,0,0,1,.13,2.49h-53a1.25,1.25,0,0,1-.13-2.5h53Z" transform="translate(-49.99 -30)" fill="#0e497b"/>
              <path id="a449288b-89b8-4afa-8633-4ec97ab931b1" d="M83.8,36.71a1,1,0,0,1,.12,2H71.56a1,1,0,0,1-.12-2H83.8Z" transform="translate(-49.99 -30)" fill="#0e497b"/>
              <path id="bde414b6-d7ef-4217-8e40-6a4716df1d37" d="M77.68,83.12a9.71,9.71,0,0,1,6.57,2.6,1.25,1.25,0,0,1-1.69,1.85,7.08,7.08,0,0,0-9.76,0,1.25,1.25,0,1,1-1.69-1.85A9.74,9.74,0,0,1,77.68,83.12Z" transform="translate(-49.99 -30)" fill="#ffb81c"/>
              <path id="b2d68172-85ce-4eec-9d12-2b390a1f6f6a" d="M77.68,74.1a18.24,18.24,0,0,1,12.77,5.25,1.25,1.25,0,1,1-1.74,1.79,15.67,15.67,0,0,0-22.06,0,1.25,1.25,0,1,1-1.74-1.79A18.24,18.24,0,0,1,77.68,74.1Z" transform="translate(-49.99 -30)" fill="#ffb81c"/>
              <path id="bfd58518-2202-491d-a402-f433f657bd68" d="M77.68,65.08A26.77,26.77,0,0,1,96.62,73a1.25,1.25,0,1,1-1.76,1.77,24.17,24.17,0,0,0-34.36,0A1.25,1.25,0,1,1,58.74,73,26.77,26.77,0,0,1,77.68,65.08Z" transform="translate(-49.99 -30)" fill="#ffb81c"/>
              <path id="adb86967-7809-4720-a01c-1919a675d5e5" d="M77.68,120.14a3.58,3.58,0,1,1,3.58-3.58,3.58,3.58,0,0,1-3.58,3.58" transform="translate(-49.99 -30)" fill="#0e497b" fillRule="evenodd"/>
            </g>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'MobileDeviceWithWifiSymbolIcon';

export default Icon;
